const activateGridBannerVideo = (video) => {
  if (!video || video.dataset.gridBannerReady === "true") return;
  const rect = video.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return;

  if (video.dataset.poster) video.poster = video.dataset.poster;
  if (video.dataset.src) video.src = video.dataset.src;
  video.dataset.gridBannerReady = "true";
  video.load();
  video.play().catch(() => undefined);
};

const videos = Array.from(document.querySelectorAll("[data-grid-banner-video]"));

if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activateGridBannerVideo(entry.target);
        } else if (!entry.target.paused) {
          entry.target.pause();
        }
      });
    },
    { rootMargin: "400px 0px", threshold: 0.01 },
  );

  videos.forEach((video) => observer.observe(video));

  let resizeTimer;
  window.addEventListener(
    "resize",
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        videos.forEach((video) => {
          const rect = video.getBoundingClientRect();
          if (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top < window.innerHeight + 400 &&
            rect.bottom > -400
          ) {
            activateGridBannerVideo(video);
          }
        });
      }, 120);
    },
    { passive: true },
  );
} else {
  videos.forEach(activateGridBannerVideo);
}
